<template>
  <div v-if="page.contacts" class="page page-dark page-contacts">
    <div class="container">
      <div class="col-md-12">
        <h2 class="page-contacts--phone"><a href="tel:+74959337086">+7 495 933-70-86</a></h2>
      </div>
    </div>

    <div class="container">
      <div class="col-md-6" v-html="page.contacts.text_address"/>
    </div>

    <div class="container footer-container font-grotesque">
      <div class="col-als">
        <a href="https://300.pravo.ru/rating/499/">
          <p><img width="87" src="/static/pravo-007-orange.svg"/></p>
        </a>
      </div>
      <div class="col-als col-als-wrap col-als-desc">
        <div v-html="page.contacts.text_pravo_300_dark"/>
      </div>
      <div class="col-als col-als-wrap">
        <div class="col-als-logo">
        <a :href="lang === 0 ? 'https://artlebedev.ru' : 'https://artlebedev.com'">
          <svg version="1" id="ALS_logo_svg" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="100" height="46" viewBox="0 0 100 46"><path fill="#ff9933" d="M0 0h100v34H0V0z"/><path fill="#ffffff" d="M80.649 22.75l-.601 4.26h-.249l-.337-4.135L78.811 4H77l1.499 26h2.619L83.6 4h-2.072zM67.569 4H64v26h3.439C69.415 30 70 28.84 70 27V6.766C70 4.924 69.545 4 67.569 4zM68 27.462c0 1.323.06 1.538-1 1.538h-1V5h1c1.06 0 1 .216 1 1.538v20.924zM72 30h4v-1h-2V16h1.341v-1H74V5h2V4h-4zM18 4l-2 26h1.525l.736-8H20l.227 8h2.075L20.85 4H18zm.332 17l.6-11.745.298-3.156h.57l.2 3.156V21h-1.668zM43 4h-2v26h4v-1h-2zM46 30h4v-1h-2V16h1.326v-1H48V5h1.989V4H46zM30.713 5h1.666v25h1.861V5h1.601V4h-5.128zM36.617 27.939c-.669 0-1.205.533-1.205 1.192 0 .663.536 1.193 1.205 1.193.668 0 1.205-.531 1.205-1.193 0-.659-.537-1.192-1.205-1.192zM55.709 4H51v26h3.94c1.249 0 2.045-1.001 2.06-2.094V17.631c0-1.255-.219-1.569-.666-1.822v-.564c.551-.275.666-.556.666-1.433v-8.23C57 4.661 56.652 4 55.709 4zM55 28.104c-.012.689-.057.832-.61.832h-1.403L53 16h1.406c.551 0 .594.3.594 1.422v10.682zm0-14.463c0 1.091.028 1.303-.551 1.359H53l-.014-10h1.447c.466 0 .567.216.567.792v7.849zM27.594 4H24v26h2V18h1.331c.61 0 .669.283.669 1v11h2l-.011-9.89c0-1.425.073-1.794-.724-2.259v-.603c.53-.057.735-.125.735-1.534V7c0-1.842-.445-3-2.406-3zM28 16c0 .805.02 1-.636 1H26V5l.84-.016C27.883 5 28 5.677 28 7v9zM59 30h4v-1h-2V16h1.336v-1H61V5h2V4h-4z"/><path fill="#ff9933" d="M3.502 39.877c0-.738-.558-1.08-1.098-1.08-.486 0-1 .261-1.387.576l-.405-.495c.468-.522 1.234-.828 1.918-.828.981 0 1.909.567 1.909 1.827 0 1.54-1.773 3.241-2.791 4.178h2.881v.792H.54v-.648c.99-1.027 2.962-2.756 2.962-4.322zM8.389 45c-1.863 0-2.386-1.963-2.386-3.476 0-1.512.522-3.475 2.386-3.475s2.386 1.963 2.386 3.475C10.774 43.037 10.252 45 8.389 45zm0-6.275c-1.269 0-1.503 1.837-1.503 2.8 0 .964.234 2.81 1.503 2.81 1.27 0 1.504-1.846 1.504-2.81 0-.963-.235-2.8-1.504-2.8zm3.882.63l1.944-1.152h.567v5.987l1.197.216v.441h-3.286v-.441l1.197-.216v-4.997c.009-.009-1.458.541-1.458.541l-.161-.379zM19.918 45c-1.17 0-2.261-.631-2.261-1.801 0-.873.865-1.624 1.541-1.929-.693-.36-1.48-.681-1.48-1.591 0-1.044 1.165-1.678 2.2-1.678 1.053 0 2.275.598 2.275 1.678 0 .9-.813 1.8-1.546 1.555.841.281 1.688 1.02 1.688 1.965C22.334 44.334 21.043 45 19.918 45zm-.054-3.759c-.742.372-1.414 1.175-1.414 1.941 0 .737.748 1.161 1.468 1.161s1.633-.414 1.633-1.161c0-.914-.697-1.546-1.687-1.941zm.054-2.722c-.63 0-1.417.512-1.417 1.169 0 .675.949 1.539 1.507 1.791.576-.297 1.471-1.062 1.471-1.791 0-.621-.958-1.169-1.561-1.169z"/></svg>
        </a>
        </div>
        <div class="col-als-shield">
          <div v-html="page.contacts.text_als_footer_dark"/>
          <!-- <div class="col-als-shield-hui" v-html="page.contacts.text_als_footer_dark"/> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'contacts',
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
  }),
};
</script>


<style>
.page-dark .page-contacts{
  &--phone{
    a{
      &,
      &:hover{
        color: white !important;
      }
    }
  }
}


.col-als-shield{
  position: relative;
  &-hui{
    transition: opacity .3s ease-in-out;
    background: #020f34;
    padding-right: 18px;
    position: absolute;
    opacity: 0;
    left: 0;
    top: 0;

    &:hover{
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContactsDark.vue